import React from 'react';

import { View } from 'react-native';

import FastImage from 'react-native-fast-image';

import useImageRatio from 'utils/hooks/useImageRatio';

import NagraImage from 'components/NagraImage';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';
import { getImageUrl } from 'components/NagraImage/utils';

import styles from './styles';

type Props = {
    channelId: string;
    testID?: string;
};

function ChannelLogo({ channelId, testID }: Props) {
    const { height } = ImageSize.GALLERY_CHANNEL_LOGO;
    const channelLogoUrl = getImageUrl({
        aspect: AspectRatio.LANDSCAPE,
        contentId: channelId,
        contentType: ImageContentType.CHANNEL,
        imageType: ImageType.LOGO,
        height,
    });

    const { ratio: aspectRatio } = useImageRatio(channelLogoUrl);

    if (!channelLogoUrl) {
        return null;
    }

    return (
        <View testID={testID}>
            <NagraImage
                contentId={channelId}
                imageType={ImageType.LOGO}
                contentType={ImageContentType.CHANNEL}
                height={height}
                aspect={AspectRatio.LANDSCAPE}
                resizeMode={FastImage.resizeMode.contain}
                style={[styles.root, { aspectRatio, height }]}
            />
        </View>
    );
}

export default ChannelLogo;
